import { useEffect, useRef, useState } from "react";
import client from "../api/client";

const REFRESH_MS = 10 * 60 * 1000;
// الأولوية التصاعدية: الفرع (احتياطي) < عنوان الإنترنت < موقع الجهاز الفعلي.
const RANK = { branch: 1, ip: 2, device: 3 };

// إحداثيات الطقس مُثبّتة: نرتقي فقط لمصدر أقوى ولا ننزل أبداً، ونتجاهل التغييرات غير الفعلية.
// هذا يمنع تذبذب الموقع (بغداد↔دبي) عند تغيّر الفرع أو عدم استقرار GPS/IP بين التصييرات.
export const useWeatherCoords = (branch) => {
  const [coords, setCoords] = useState(null);
  const ref = useRef({ rank: 0, key: "" });

  const apply = (lat, lon, source) => {
    if (lat == null || lon == null) return;
    const rank = RANK[source];
    if (rank < ref.current.rank) return; // لا ننزل لمصدر أضعف
    const key = `${(+lat).toFixed(3)},${(+lon).toFixed(3)}`;
    if (rank === ref.current.rank && key === ref.current.key) return; // لا تغيير فعلي
    ref.current = { rank, key };
    setCoords({ lat: +lat, lon: +lon, source });
  };

  useEffect(() => {
    if (!navigator.geolocation) return undefined;
    let alive = true;
    const read = () =>
      navigator.geolocation.getCurrentPosition(
        (pos) => { if (alive) apply(pos.coords.latitude, pos.coords.longitude, "device"); },
        () => {},
        { enableHighAccuracy: true, timeout: 15000, maximumAge: REFRESH_MS }
      );
    read();
    const id = setInterval(read, REFRESH_MS);
    return () => { alive = false; clearInterval(id); };
  }, []);

  useEffect(() => {
    let alive = true;
    client.get("/weather/ip-coords")
      .then((r) => { if (alive && r.data?.lat != null) apply(r.data.lat, r.data.lon, "ip"); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  useEffect(() => {
    // الفرع احتياطي أولي فقط؛ لا يُعاد تطبيقه بعد توفّر أي مصدر، فلا يتذبذب الموقع.
    if (ref.current.rank !== 0) return;
    if (branch?.latitude != null && branch?.longitude != null) {
      apply(branch.latitude, branch.longitude, "branch");
    }
  }, [branch?.latitude, branch?.longitude]);

  return coords;
};
